import React from 'react';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCcAmex, faCcDiscover, faCcMastercard, faCcPaypal, faCcVisa } from '@fortawesome/free-brands-svg-icons';

/**
 * headless: apps/topmags/layouts/MainLayout/Footer/AcceptedPaymentMethods.
 *
 * DiscountMags has its own version of this under its brand folder, drawn from a
 * different icon set. Neither is in shared/ yet; the first change that genuinely needs
 * one component for both brands should promote it, rather than one brand importing
 * across into the other.
 */
export default function AcceptedPaymentMethods() {
  const paymentMethods: { icon: IconLookup }[] = [
    { icon: faCcVisa },
    { icon: faCcMastercard },
    { icon: faCcDiscover },
    { icon: faCcAmex },
    { icon: faCcPaypal },
  ];

  return (
    <div className="flex justify-center my-2 md:my-0">
      <ul className="flex gap-2">
        {paymentMethods.map(({ icon }, index) => (
          <li key={index}>
            <FontAwesomeIcon icon={icon} size="2x" className="text-gray-600" />
          </li>
        ))}
      </ul>
    </div>
  );
}
